import React from 'react'
import { useNavigate,useParams } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import {
	CHeader,CHeaderBrand,CHeaderNav,CHeaderToggler,CHeaderDivider,
	CFooter,
	CRow,
	CCol,
	CContainer,
	CForm,
	CFormInput,
	CFormTextarea,
	CInputGroup,
	CInputGroupText,
	CCard,
	CCardHeader,
	CCardBody,
	CCardFooter,
	CImage,
	CLink,
	CTooltip,
	CSpinner,
} from '@coreui/react';
import CIcon from '@coreui/icons-react'
import NumberFormat from 'react-number-format';
import { isMobile } from "react-device-detect";
import {
	MyHeaderProfile,
	MyButton,
	MyDialogform,
	MyDialoglookup,
} from '../../components/index'
import { Konfirm } from '../../helpers/onConfirm'
import { UFunc } from '../../helpers/functions'

const pjson 		= require('../../../package.json')
const Kasiredit 	= (props) => {
	const {
		setLoading,showToast,prosesExpired,setSessionaktif 
	} = props;
	const { tabel_id } 				= useParams(); 

	//--DOM--/
	const uNavigate 			= useNavigate();
	const uDispatch 			= useDispatch();
	//--END DOM--/

	const uTabelID					= parseInt(tabel_id) || 0;;

	const uBahasaObj  				= useSelector(state => state.listBahasa);
	const uActiveroute  			= useSelector(state => state.activeRoute);
	const uSettingObj 				= useSelector(state => state.gListUserSetting);
	const uIsScrollBottom			= useSelector(state => state.gIsScrollBottom);
	const uEfekapp					= useSelector(state => state.effectApp);
	const uUrlbefore 				= useSelector(state => state.gUrlbefore);

	const [uEfekview,setEfekview] 	= React.useState(false);
	const uMaxData					= isMobile ? (uSettingObj.jml_mobile || 10) : (uSettingObj.jml_laporan || 100);
	const uKeywordobj				= JSON.parse(localStorage.getItem("listkeyword")) || {};
	const uTokenObj					= JSON.parse(localStorage.getItem("token")||"{}");
	const uISHapusallow				= (uTokenObj.userhak==="FREEROLE"||uTokenObj.userhak==="ADMIN");
	const [uHtml500msg,setHtml500msg]	= React.useState(); 
	const [uTimeelapse,setTimeelapse]	= React.useState(0); 

	const [uDataAsuransiArr,setDataAsuransiArr]		= React.useState([]);
	const [uDatapaymentArr,setDatapaymentArr]		= React.useState([]);
	const [uDataloadObj,setDataloadObj]		= React.useState({});
	const [uDatamainObj,setDatamainObj]		= React.useState({})
	const [uISMainloading,setMainloading]	= React.useState(false);
	const [uISChangetriggered,setChangetriggered]= React.useState(false);
	const [uISDataupdated,setDataupdated]	= React.useState(false);

	//--DLG_FORM--/
	const [uDlgformObj,setDlgformObj]		= React.useState({})
	const [uISDlgformshow,setDlgformshow]	= React.useState(false)
	//--END DLG_FORM--/

	//--DLG_LOOKUP--/
	const [uDlglookupObj,setDlglookupObj]		= React.useState({});
	const [uISDlglookupshow,setDlglookupshow]	= React.useState(false);
	//--END DLG_LOOKUP--/

	//---HANDEL--/
	const hdlKDownDocument = (_EV) => {
		if(_EV.keyCode === 120) {
			_EV.preventDefault();
			hdlKlikSimpanmain(); return;
		}
	}
	const hdlKlikBack = async() => { 
		if(uISDataupdated) {
			if(await(Konfirm(
				"<p>Perhatian: <b>Data Sudah Ada yang Berubah</b>..</p>"+
				"<p class='classfontsmaller fst-italic'>Data yang Sudah Berubah Tidak Akan Tersimpan, dan Tidak Dapat Dikembalikan !</p>"+
				"<p>Yakin Akan Tetap KEMBALI ?</p>"+
				""))) {
				uNavigate(-1); 
			}
			return;
		}

		uNavigate(-1); 
	}
	const hdlKlikReset = async() => {
		if(uISDataupdated) {
			if(await(Konfirm(
				"<p>Perhatian: <b>Data Sudah Ada yang Berubah</b>..</p>"+
				"<p class='classfontsmaller fst-italic'>Data yang Sudah Berubah Tidak Akan Tersimpan, dan Tidak Dapat Dikembalikan !</p>"+
				"<p>Yakin Akan Tetap MERESET ?</p>"+
				""))) {
					setDatamainObj({...JSON.parse(JSON.stringify(uDataloadObj||{})), 
						init_diff:(new Date()).valueOf(),
					});
			}
			return;
		}

		/*//--UNTUK_TEST--/
		setDatamainObj({...JSON.parse(JSON.stringify(uDataloadObj||{})), 
			init_diff:(new Date()).valueOf(),
		}); return;//--*/
		apiLoaddata();
	}
	const hdlDlglookupKlikpilih = (_IDITEM) => {
		_IDITEM = parseInt(_IDITEM ?? "0"); if(_IDITEM <= 0) return;

		let vElfocus;
		if(uDlglookupObj.dlg_jenis === "PAYMENT") {
			const vArridx	= UFunc.getObjectIndeks(uDatapaymentArr,_IDITEM);
			setDlgformObj({...uDlgformObj,
				payment_id: uDatapaymentArr[vArridx].id,
				payment_caption: uDatapaymentArr[vArridx].nama_payment,
			});

			vElfocus = document.getElementById("inpjmlbayar");
		} /*else if(uDlglookupObj.dlg_jenis === "ASURANSI") {
			const vArridx	= UFunc.getObjectIndeks(uDataasuransiArr,_IDITEM);
			setDlgformObj({...uDlgformObj,
				asuransi_id: uDataasuransiArr[vArridx].id,
				asuransi_caption: uDataasuransiArr[vArridx].asuransi_caption,
			});

			vElfocus = document.getElementById("inpasuransinilai");
		}//-*/
		setDlglookupshow(false);
		
		let vTimeout = setTimeout(()=>{
			clearTimeout(vTimeout);

			vElfocus && vElfocus.focus();
		},350) 
	}
	const hdlKlikAsuransi = () => {}
	const hdlKlikAsuransihapus = () => {}
	const hdlKlikPaymenttambah = () => {
		const vNilaisisa	= parseFloat(uDatamainObj.nilai_sisa ?? "0");

		if(vNilaisisa <= 0) {
			showToast("<p><b>Nilai Pembayaran Sudah Melebihi Tagihan</b>..</p>"+
				"<p>Hapus Terlebih Dahulu Salah Satu Metode Pembayaran yang Ada !</p>"+
				""); return;
		}

		setDlgformObj({
			dlg_jenis:"PAYMENT",
			dlg_header:"Input Metode Pembayaran",
		});
		setDlgformshow(true);
	}
	const hdlKlikPaymentedit = (_IDXKEY) => {
		_IDXKEY	= parseInt(_IDXKEY ?? "-1"); if(_IDXKEY < 0) return;

		const vPaymentdataObj	= (uDatamainObj.payment_arr||[])[_IDXKEY] || {};
		setDlgformObj({
			dlg_jenis:"PAYMENT",
			dlg_header:"Edit Metode Pembayaran",
			idxkey: _IDXKEY,
			payment_id: parseInt(vPaymentdataObj.id_payment ?? "0"),
			payment_caption: vPaymentdataObj.metode_payment || "",
			payment_ket: vPaymentdataObj.ket_payment || "",
			jml_bayar: parseFloat(vPaymentdataObj.nilai_uang ?? "0"),
			nilai_bayar: parseFloat(vPaymentdataObj.nilai_bayar ?? "0"),
		});
		setDlgformshow(true);
	}
	const hdlKlikPaymenthapus = async(_IDXKEY) => {
		_IDXKEY = parseInt(_IDXKEY ?? "-1"); if(_IDXKEY < 0) return;

		const vNextfunction = () => {
			const vTabelid = parseInt((uDatamainObj.payment_arr||[])[_IDXKEY].id ?? "0");

			if(vTabelid <= 0) 
				(uDatamainObj.payment_arr||[]).splice(_IDXKEY,1);
			else
				(uDatamainObj.payment_arr||[])[_IDXKEY] = {
					...((uDatamainObj.payment_arr||[])[_IDXKEY] || {}),
					status_hapus: "YA",
				}

			setChangetriggered(true);
		}

		if(await Konfirm("<b>Metode Pembayaran Akan Dihapus</b>.."+
			"<br/>Apakah Anda Yakin ?"+
			"")) {

			vNextfunction();
		}
	}
	const hdlKlikPaymentlookup = () => {
		const vTmpArr	= uDatapaymentArr.map(vItems => {
			return {
				id:vItems.id,
				caption:vItems.nama_payment,
			}
		});

		setDlglookupObj({
			dlg_jenis: "PAYMENT",
			dlg_header:  "Pilih: METODE PEMBAYARAN",
			data_arr: vTmpArr,
		});
		setDlglookupshow(true);
	}
	const hdlKlikDlgformsimpan = () => {
		if(uDlgformObj.dlg_jenis === "FORMMAIN") {
			apiProsessimpan(); return;
		}
		if(uDlgformObj.dlg_jenis === "PAYMENT") {
			prosesFormpayment(); return;
		}
	}
	const hdlKlikSimpanmain = () => {
		if(!uISDataupdated) return;

		let vElfocus	= document.getElementById("inpbayar");
		if(uDatamainObj.status_bayar !== "KASIR")
			if(parseFloat(uDatamainObj.nilai_uang ?? "0") <= 0) {
				vElfocus && vElfocus.focus();
				showToast("JML Bayar Tidak Valid ! "); return
			}

		setDlgformObj({
			dlg_jenis: "FORMMAIN",
			dlg_header: "Simpan Perubahan Nota",
		})
		setDlgformshow(true);

		let vTimeout = setTimeout(()=>{
			clearTimeout(vTimeout);

			document.getElementById("btnDialogSimpan") && 
				document.getElementById("btnDialogSimpan").focus();
		},550)
	}
	//---END HANDEL--/

	//---INIT_PROCESS--/
	const prosesFormpayment = () => {
		const vPaymentID	= parseInt(uDlgformObj.payment_id)||0;
		const vJumlahbayar	= parseFloat(uDlgformObj.jml_bayar)||0;
		if(vJumlahbayar <= 0 && vPaymentID <= 0) {
			setDlgformshow(false); return;
		}

		let vArridx		= parseInt(uDlgformObj.idxkey ?? "-1");
		const vFilterArr= (uDatamainObj.payment_arr||[]).filter((vItems,vKeys)=>{
			return (parseInt(vItems.id_payment ?? "0") === vPaymentID &&
				vKeys !== vArridx)
		});
		let vISRevalidate = false;
		//alert(vArridx+" == "+vPaymentID+" == "+JSON.stringify(uDatamainObj.payment_arr||[]));

		let vElfocus		= document.getElementById("inppaymentcaption");
		if(vFilterArr.length > 0) {
			//console.log("(Kasiredit - prosesFormpayment) vFilterArr.status_hapus",vFilterArr.status_hapus);
			if((vFilterArr[0].status_hapus||"TIDAK") === "TIDAK") {
				vElfocus && vElfocus.focus();
				showToast("<p><b>Metode Pembayaran Sudah Ada</b>.."+
					"<br/>Mohon Diperbaiki !</p>"+
					""); return
			}
			vArridx 		= UFunc.getObjectIndeks((uDatamainObj.payment_arr||[]),vFilterArr[0].id);
			vISRevalidate 	= true;
		}

		const vNilaisisa	= parseFloat(uDatamainObj.nilai_sisa ?? "0")
			+ parseFloat(uDlgformObj.nilai_bayar ?? "0"); 
		const vNilaisisabaru= vNilaisisa - vJumlahbayar; 
		vElfocus	= document.getElementById("inpjmlbayar");
		if(vJumlahbayar <= 0) {
			vElfocus && vElfocus.focus();
			showToast("<b>Jumlah Pembayaran Tidak Valid</b>.."+
				"<br/>Mohon Diperbaiki !"+
				""); return
		}

		if(vPaymentID > 0 && vNilaisisabaru < 0) {
			vElfocus && vElfocus.focus();
			showToast("<b>Jumlah Pembayaran Melebihi Nilai Tagihan</b>.."+
				"<br/>Mohon Diperbaiki !"+
				""); return
		}

		const vNilaibayar = (vNilaisisabaru < 0) 
			? (vJumlahbayar - Math.abs(vNilaisisabaru)) : vJumlahbayar;

		let vTmpObj	= {
			id_payment: parseInt(uDlgformObj.payment_id ?? "0"),
			metode_payment: uDlgformObj.payment_caption || "Tunai (CASH)",
			ket_payment: (uDlgformObj.payment_ket||"").trim(),
			nilai_bayar: vNilaibayar,
			nilai_uang: vJumlahbayar,
		}

		if(vArridx < 0)
			setDatamainObj({...uDatamainObj,
				payment_arr: [...(uDatamainObj.payment_arr||[]),vTmpObj],
			})
		else {
			if(vISRevalidate) vTmpObj = {...vTmpObj,status_hapus:undefined};

			(uDatamainObj.payment_arr||[])[vArridx] = {
				...((uDatamainObj.payment_arr||[])[vArridx] || {}),
				...vTmpObj,
			} 
		}

		setChangetriggered(true);
		setDlgformshow(false);

		let vTimeout = setTimeout(()=>{
			clearTimeout(vTimeout);

			document.getElementById("btnSimpanmain") && 
				document.getElementById("btnSimpanmain").focus();
		},350)
	}
	//---END INIT_PROCESS--/

	//---CONTENT--/
	const contentHeadersub = () => {
		if(uHtml500msg) return (
		<>
		<i>Page 500</i>
		<CLink onClick={()=>hdlKlikReset()} className="classcursorpointer classikon classikonreset"/>
		</>
		)//>

		if(uISMainloading) return (
		<div className="text-center w-100 classfontsmaller">
			<i className="text-primary classblinking">Loading...</i>
		</div>
		)//>

		return (
		<>
			<div>
			<b>{uDatamainObj.nota}</b> &middot; <small className="text-danger">[{uDatamainObj.kasir}]</small>
			</div>

			<div style={{minWidth:100}} className="text-center">
			<CLink onClick={()=>hdlKlikReset()} className="classikon classikonreset classcursorpointer"/>
			</div>
		</>
		)//>
	}
	const contentNota = () => {
		if(uHtml500msg) return ""

		return (
		<small>
		<div className="d-flex justify-content-between my-2">
			<span>Tgl Pembayaran</span>
			<b>{UFunc.WaktuAngka(uDatamainObj.tgl_bayar)}</b>
		</div>

		{UFunc.TglAngka(uDatamainObj.tgl_periksa) !== UFunc.TglAngka(uDatamainObj.tgl_bayar) && (
		<>
		<div className="classborderbottom my-3"/>

		<div className="d-flex justify-content-between my-2">
			<span>Tgl Periksa</span>
			<b>{UFunc.TglAngka(uDatamainObj.tgl_periksa)}</b>
		</div>
		</>
		)}

		<div className="d-flex justify-content-between my-2">
			<span>Nama Pasien</span>
			<b className="text-info">{uDatamainObj.pasien_caption || "Undf Pasien"}</b>
		</div>

		<div className="d-flex justify-content-between my-2">
			<span>Dokter</span>
			<b>{uDatamainObj.nama_dokter || "Undf Dokter"}</b>
		</div>
		</small>
		)//>
	}
	const contentItem = () => {
		if(uHtml500msg) return ""

		const vSumTotal = (uDatamainObj.items_arr||[]).reduce((vSUMS,vItems)=>
			vSUMS + (parseInt(vItems.qty ?? "1") * (
				(parseFloat(vItems.tarif_terapi ?? "0") - parseFloat(vItems.diskon_terapi ?? "0"))
			))
		,0);

		return (
		<small>
		<table id="idtabelitem" className="table table-borderless table-striped">
		<thead>
			<tr className="text-center align-top classfontsmaller">
			<th width={30} className="fw-normal"><small>No</small></th> 
			<th className="text-start fw-normal"><small>Item</small></th> 
			<th width="20%" className="fw-normal" style={{minWidth:125}}><small>Nilai (Rp)</small></th> 
			</tr>
		</thead>

		<tbody>
		{(uDatamainObj.items_arr||[]).map((vItems,vKeys)=>{
			const {
				caption_terapi,qty,tarif_terapi,diskon_terapi,
				id
			} = vItems;

			const vHargaterapi = parseInt(qty ?? "1") * (
				(parseFloat(tarif_terapi ?? "0") - parseFloat(diskon_terapi ?? "0"))
			);
			return (
			<tr key={vKeys} className="align-top">
				<td className="px-1 text-end">{vKeys+1}.</td>
				
				<td className="px-1 text-start">
					<div className="fw-bolder fst-italic">{caption_terapi}</div>
					<small className="d-block">
						<b>{UFunc.formatAngka(qty)}</b>Unt
						
						<span> x </span>

						{parseFloat(diskon_terapi ?? "0") > 0 && (<span>(</span>)}
						<b className="text-primary">{UFunc.formatAngka(tarif_terapi)}</b>

						{parseFloat(diskon_terapi ?? "0") > 0 && (
						<>
							<span>-</span>
							<span className="text-danger">{UFunc.formatAngka(diskon_terapi)}</span>
						</>
						)}

						{parseFloat(diskon_terapi ?? "0") > 0 && (<span>)</span>)}
					</small>
				</td>
				
				<td className="px-1 text-end">{UFunc.formatAngka(vHargaterapi)}</td>
			</tr>
			)//>
		})}
		</tbody>

		<tfoot>			
		{parseFloat(uDatamainObj.diskon ?? "0") > 0 && (
		<>
		<tr className="border-top">
			<td colSpan={2} className="text-end"><small>Jumlah</small></td>
			<td className="text-end"><small>{UFunc.formatAngka(vSumTotal)}</small></td>
		</tr>
		<tr>
			<td colSpan={2} className="text-end text-danger"><small>Diskon (Rp)</small></td>
			<td className="text-end text-danger"><small>{UFunc.formatAngka(uDatamainObj.diskon)}</small></td>
		</tr>
		</>
		)}
		
		<tr className="fw-bolder bg-dark text-white">
			<td colSpan={2} className="text-end">TOTAL</td>
			<td className="text-end">{UFunc.formatAngka(vSumTotal - parseFloat(uDatamainObj.diskon ?? "0"))}</td>
		</tr>
		</tfoot>
		</table>
		</small>
		)//>
	}
	const contentAsuransi = () => {
		if (uHtml500msg) return "";

		if(parseInt(uDatamainObj.id_asuransi ?? "0") <= 0) return (
		<small style={{color:"purple"}}>
		<div className="d-flex justify-content-between my-2">
			<div>
			<span>Tanggungan Asuransi &middot; (Rp)</span>
			
			{(uDatamainObj.status_bayar !== "PIUTANG" && 1===3) && (
			<>
			<span> &middot; </span>
			<CTooltip className="d-none d-lg-block" content="--Pilih Asuransi">
			<CLink onClick={()=>hdlKlikAsuransi()} className="classikontabel classikontambah classcursorpointer"/>
			</CTooltip>
			</>
			)}
			
			</div>

			<span>0</span>
		</div>
		</small>
		)//>

		return (
		<small>
		<div className="d-flex justify-content-between my-2" style={{color:"purple"}}>
			<div>
			<span>Asuransi: <b>{uDatamainObj.nama_asuransi || "Undf Asuransi"}</b></span>
			<span> &middot; </span>
			<span> (Rp) </span>

			{(uDatamainObj.status_bayar !== "PIUTANG" && 1===3) && (
			<>
			<span> &middot; </span>

			<span>
				<CTooltip className="d-none d-lg-block" content="--Edit Asuransi">
					<CLink onClick={()=>hdlKlikAsuransi()} className="classikontabel classikonedit classcursorpointer"/>
				</CTooltip>

				<CTooltip className="d-none d-lg-block" content="--Batalkan Asuransi">
					<CLink onClick={()=>hdlKlikAsuransihapus()} className="classikontabel classikonhapus classcursorpointer"/>
				</CTooltip>
			</span>
			</>
			)}
			</div>
			
			<b>Rp {UFunc.formatAngka(uDatamainObj.nilai_asuransi)}</b>
		</div>
		</small>
		)//>
	}
	const contentPayment = () => {
		if (uHtml500msg) return "";

		let vNumberpayment = 0;

		return (
		<small>
		{(uDatamainObj.status_bayar === "PIUTANG") && (
		<>
		<div className="d-flex justify-content-between my-2">
			<span>Nilai Total &middot; (Rp)</span>
			<b>{UFunc.formatAngka(uDatamainObj.nilai_total)}</b>
		</div>

		<div className="d-flex justify-content-between my-2">
			<span>Terbayar Sebelumnya &middot; (Rp)</span>
			<b>{UFunc.formatAngka(uDatamainObj.bayar_before)}</b>
		</div>

		<div className="classborderbottom my-3"/>
		</>
		)}

		<div className="d-flex justify-content-between my-2 text-success">
			<span>Nilai Tagihan &middot; (Rp)</span>
			<b>{UFunc.formatAngka(uDatamainObj.nilai_tagihan)}</b>
		</div>

		<div className="classborderbottom my-3"/>

		<div className="d-flex justify-content-between my-2">
			<div>
				<span className="text-primary">Metode Pembayaran</span>
				<span> &middot; </span>

				<CTooltip className="d-none d-lg-block" content="--Tambah Metode Pembayaran">
				<CLink onClick={()=>hdlKlikPaymenttambah()} className="classcursorpointer classikontabel classikontambah"/>
				</CTooltip>
			</div>
			<span>[ {(uDatamainObj.payment_arr||[]).
				filter(vItems=>(vItems.status_hapus||"TIDAK")==="TIDAK").
				length} ]</span>
		</div>

		{(uDatamainObj.payment_arr||[]).
			//filter(vItems=>(vItems.status_hapus||"TIDAK")==="TIDAK").
			map((vItems,vKeys)=>{
			const {
				metode_payment,nilai_bayar,nilai_uang,id,status_hapus,ket_payment,
			} = vItems;

			if((status_hapus||"TIDAK")==="TIDAK") vNumberpayment++;

			return (
			<div className={((status_hapus||"TIDAK")==="YA"?"d-none":"d-flex")+" justify-content-between my-2"} 
				key={vKeys}>
				<div style={{minWidth:180,width:"70%"}} className="d-flex">
					<span style={{width:"7%"}} className="text-end">{vNumberpayment}.</span>

					<span style={{minWidth:100,width:"60%"}} className="px-1 d-inline-block">
						<div className="fw-bolder">{metode_payment || "Nama Payment"}</div>
						<div className="classfontsmaller"><i>{ket_payment}</i></div>
					</span>
					
					<div style={{minWidth:80}}>
					<CTooltip className="d-none d-lg-block" content={"--Edit Nilai: "+(metode_payment||"Undf").toUpperCase()}>
					<CLink onClick={()=>hdlKlikPaymentedit(vKeys)} className="classcursorpointer classikontabel classikonedit"/>
					</CTooltip>

					<CTooltip className="d-none d-lg-block" content={"--Hapus: "+(metode_payment||"Undf").toUpperCase()}>
					<CLink onClick={()=>hdlKlikPaymenthapus(vKeys)} className="classcursorpointer classikontabel classikonhapus"/>
					</CTooltip>

					<span className="d-none d-md-inline">&middot; </span>
					<span className="d-none d-md-inline">(Rp) </span>
					</div>
				</div>

				<span>{UFunc.formatAngka(nilai_uang)}</span>
			</div>
			)//>
		})}

		<div className="d-flex justify-content-between my-2 text-primary fw-bolder">
			<big>JML BAYAR &middot; (Rp)</big>
			<big>{UFunc.formatAngka(uDatamainObj.nilai_uang)}</big>
		</div>

		<div className="classborderbottom my-3"/>

		{parseFloat(uDatamainObj.nilai_sisa ?? "0") <= 0 ? (
			<div className="d-flex justify-content-between my-2 text-success">
				<span>KEMBALI &middot; (Rp)</span>
				<big className="fw-bolder">{UFunc.formatAngka(Math.abs(uDatamainObj.nilai_sisa))}</big>
			</div>
		) : (
			<div className="d-flex justify-content-between my-2 text-danger">
				<span>Sisa Cicilan (Piutang) &middot; (Rp)</span>
				<big className="fw-bolder">{UFunc.formatAngka(uDatamainObj.nilai_sisa)}</big>
			</div>
		)}

		</small>
		)//>
	}
	const contentDlgform = () => {
		if(!uISDlgformshow) return (<></>)//->

		//if(uDlgformObj.dlg_jenis === "ASURANSI") return contentFormasuransi();
		if(uDlgformObj.dlg_jenis === "FORMMAIN") return contentFormmain();
		if(uDlgformObj.dlg_jenis === "PAYMENT") return contentFormpayment();

		return (<></>)//->
	}
	const contentFormpayment = () => {
		if(uDlgformObj.dlg_jenis !== "PAYMENT") return "";

		const vArridx		= parseInt(uDlgformObj.idxkey ?? "-1");
		const vNilaisisa 	= parseFloat(uDatamainObj.nilai_sisa ?? "0") 
			+ parseFloat(uDlgformObj.nilai_bayar ?? "0"); 

		return (
		<CForm>
		<CRow className="my-2 text-danger">
			<CCol xs="3" md="4">
			<small className="d-md-none">Sisa</small>
			<span className="d-none d-md-block">Sisa Tagihan (Rp)</span>
			</CCol>

			<CCol className="text-end fw-bolder">{UFunc.formatAngka(vNilaisisa)}</CCol>
		</CRow>
			
		<div className="my-3 classborderbottom"/>

		<CRow className="my-2">
			<CCol xs="3" md="4">
				<small className="d-md-none">Metode</small>
				<span className="d-none d-md-block">Metode Payment</span>
			</CCol>

			<CCol className="text-end">
			{vArridx < 0 ? (
			<CInputGroup size="sm">
				<CFormInput size="sm"
					value={uDlgformObj.payment_caption||""}
					readOnly={true}
					onClick={()=>hdlKlikPaymentlookup()}
					placeholder="--Kosongi Jika TUNAI (CASH).."
					id="inppaymentcaption"/>
				{parseInt(uDlgformObj.payment_id ?? "0") > 0 && (
				<CInputGroupText className="py-0 bg-transparent">
					<CLink className="classcursorpointer"
						onClick={()=>setDlgformObj({...uDlgformObj, 
							payment_id:0,
							payment_caption:"",
						})}>
					<CIcon icon="cilXCircle" className="text-danger"/>
					</CLink>
				</CInputGroupText>
				)}
				<CInputGroupText className="py-0 bg-dark">
				<CTooltip className="d-none d-lg-block" content="--Pilih Metode Pembayaran">
				<CLink 
					className="classcursorpointer"
					onClick={()=>hdlKlikPaymentlookup()}>
					<CIcon icon="cilMagnifyingGlass" className="text-light"/>
				</CLink>
				</CTooltip>
				</CInputGroupText>
			</CInputGroup>
			) : (
				<b className="text-uppercase">{uDlgformObj.payment_caption||""}</b>
			)}
			</CCol>
		</CRow>

		{(parseInt(uDlgformObj.payment_id) || 0) > 0 && (
		<CRow className={"my-2 "}>
			<CCol xs="3" md="4">
			<small className="d-md-none">Ket.Payment</small>
			<span className="d-none d-md-block">Ket.Payment</span>
			</CCol>

			<CCol>
			<CFormInput size="sm" maxLength={255}
				readOnly={false}
				className="text-capitalize"
				value={uDlgformObj.payment_ket||""}
				onChange={(e)=>{uDlgformObj.payment_ket=e.target.value;setEfekview(!uEfekview)}}
				id="inppaymentket"/>
			</CCol>
		</CRow>
		)}

		<div className="classborderbottom my-3"/>

		<CRow className="my-2">
			<CCol xs="3" md="4">
				<small className="d-md-none">Jml Bayar</small>
				<span className="d-none d-md-block">Jml Bayar (Rp)</span>
			</CCol>

			<CCol>
				<NumberFormat 
					value={uDlgformObj.jml_bayar||"0"}
					displayType={'text'} 
					allowNegative={false}
					thousandSeparator={"."} 
					decimalSeparator={","}
					onValueChange={(values) => uDlgformObj.jml_bayar=values.value}
					renderText={values => (
						<CFormInput size="sm"
							value={values}
							className="text-end"
							onChange={(e)=>{uDlgformObj.jml_bayar=e.target.value;setEfekview(!uEfekview)}}
							onFocus={(e)=>e.target.select()}
							onKeyDown={(e)=>UFunc.hdlKeyDownInput(e,"btnDialogSimpan")}
						id="inpjmlbayar"/>
					)} 
				prefix=""/>
			</CCol>
		</CRow>
		</CForm>
		)//>
	}
	const contentFormmain = () => {
		if(uDlgformObj.dlg_jenis !== "FORMMAIN") return (<></>)//>

		return (
		<CForm>
		<CRow className="my-1">
		<CCol>Nomor Nota</CCol>
		<CCol className="text-end fw-bolder">{(uDatamainObj.nota||"").toUpperCase()}</CCol>
		</CRow>

		{parseInt(uDatamainObj.id_asuransi ?? "0") > 0 && (
		<CRow className="my-1">
		<CCol className="" style={{color:"purple"}}>Asuransi (<b>{uDatamainObj.nama_asuransi}</b>)</CCol>
		<CCol className="text-end fw-bolder" style={{color:"purple"}}>{UFunc.formatAngka(uDatamainObj.nilai_asuransi)}</CCol>
		</CRow>
		)}

		<div className="my-3 classborderbottom"/>

		<CRow className="my-1">
		<CCol>Nilai Tagihan</CCol>
		<CCol className="text-end fw-bolder">{UFunc.formatAngka(uDatamainObj.nilai_tagihan)}</CCol>
		</CRow>


		<CRow className="my-1">
		<CCol className="text-primary">Jml BAYAR</CCol>
		<CCol className="text-end fw-bolder text-primary">{UFunc.formatAngka(uDatamainObj.nilai_uang)}</CCol>
		</CRow>

		<div className="my-3 classborderbottom"/>

		<CRow className="my-1">
		{parseInt(uDatamainObj.nilai_sisa ?? "0") > 0 ? (
		<>
			<CCol className="text-danger"><big>Sisa Piutang</big></CCol>
			<CCol className="text-end fw-bolder text-danger"><big>{UFunc.formatAngka(uDatamainObj.nilai_sisa)}</big></CCol>
		</>
		) : (
		<>
			<CCol className="text-success">Kembalian</CCol>
			<CCol className="text-end fw-bolder text-success">{UFunc.formatAngka(Math.abs(uDatamainObj.nilai_sisa))}</CCol>
		</>
		)}
		</CRow>
		</CForm>
		)//->
	}
	//---END CONTENT--/

	//---REST_API--/
	const apiLoaddata = async() => {
		setHtml500msg();//return;

	    setDataAsuransiArr([]);
	    setDatapaymentArr([]);
	    setDataloadObj({});

		const vDATAS    = JSON.stringify({
			send_tabelid: uTabelID,
			send_tokenauth : uTokenObj.userinit
		});
		const vHeaderObj	= {
			headers: { Accept: "application/json", "Content-Type": "application/json" },
			method: "POST", mode: "cors",
			cache: "default",
		}

		setLoading(true);
		setMainloading(true);

		try {
			setSessionaktif(false);
			setTimeelapse(0);
			const vTimeBegin = new Date();

			const [output_asuransi,output_payment,output_main] = await Promise.all([
				(async () => {
					const vURLs	= pjson.homepage+"api2/api_lapomzet/ld_masterasuransi";
					const vDATAS= JSON.stringify({
						send_tokenauth : uTokenObj.userinit
					});
					const response = await fetch(vURLs,{...vHeaderObj,body:vDATAS});
					if (!response.ok) throw new Error('Network response ASURANSI was not ok.');
					return response.json();
				})(),

				(async () => {
					const vURLs	= pjson.homepage+"api2/api_rekapnota/ld_payment";
					const vDATAS= JSON.stringify({
						send_tokenauth : uTokenObj.userinit
					});
					const response = await fetch(vURLs,{...vHeaderObj,body:vDATAS});
					if (!response.ok) throw new Error('Network response PAYMENT was not ok.');
					return response.json();
				})(),
					
				(async () => {
					const vURLs			= pjson.homepage+"api2/api_rekapnota/ld_nota";
					const vDATAS		= JSON.stringify({
						send_tabelid: uTabelID,
						send_cabangid: uTokenObj.user_cabangid,
						send_tokenauth: uTokenObj.userinit
					});

					const response = await fetch(vURLs,{...vHeaderObj,body:vDATAS});
					if (!response.ok) throw new Error('Network response MAIN was not ok.');
					return response.json();
				})()//-*/
			]);

			setSessionaktif(true);
			//--output_asuransi--/
			if(output_asuransi.tampil) {
				setDataAsuransiArr(JSON.parse(output_asuransi.dataasuransi||"[]"))
			} else if(output_asuransi.info) {
				setHtml500msg(output_asuransi.info); return;
			} else if(output_asuransi.errors) {
				console.log("(Kasiredit - apiLoaddata) output_asuransi.errors : "+output_asuransi.errors);
				const vMsg = (pjson.mydefault.environment==="development")
					? output_asuransi.errors : pjson.mydefault.msgFetchError;
				setHtml500msg("<div class='text-danger'>"+vMsg+"</div>"); return;
			} else if(output_asuransi.expired) {
				setLoading(true); prosesExpired(); return;
			}
			//--END output_asuransi--/

			//--output_payment--/
			if(output_payment.tampil) {
				setDatapaymentArr(JSON.parse(output_payment.datapayment||"[]"))
			} else if(output_payment.info) {
				setHtml500msg(output_payment.info); return;
			} else if(output_payment.errors) {
				console.log("(Kasiredit - apiLoaddata) output_payment.errors : "+output_payment.errors);
				const vMsg = (pjson.mydefault.environment==="development")
					? output_payment.errors : pjson.mydefault.msgFetchError;
				setHtml500msg("<div class='text-danger'>"+vMsg+"</div>"); return;
			} else if(output_payment.expired) {
				setLoading(true); prosesExpired(); return;
			}
			//--END output_payment--/

			//--output_main--/
			if(output_main.tampil) {
				const vDatamainObj	= JSON.parse(output_main.datanota||"{}");
				//console.log("(Kasiredit - apiLoaddata) vDatamainObj",vDatamainObj);
				setDataloadObj(vDatamainObj);
			} else if(output_main.info) {
				setHtml500msg(output_main.info); return;
			} else if(output_main.errors) {
				console.log("(Kasiredit - apiLoaddata) output_main.errors : "+output_main.errors);
				const vMsg = (pjson.mydefault.environment==="development")
					? output_main.errors : pjson.mydefault.msgFetchError;
				setHtml500msg("<div class='text-danger'>"+vMsg+"</div>"); return;
			} else if(output_main.expired) {
				setLoading(true); prosesExpired(); return;
			}
			//--END output_main--/

		} catch (error) {
			console.log("(Kasiredit - apiLoaddata) catch-error : "+error.message);
			setHtml500msg(pjson.mydefault.msg500str.join(" "));
		} finally {
			setLoading(false);
			setMainloading(false);
		}
	}
	const apiProsessimpan = () => {
		const vEldisabled = document.getElementById("btnDialogSimpan");
		vEldisabled && (vEldisabled.disabled = true);
		setLoading(true); 

		const vDATAS	= JSON.stringify({
			send_tabelid : uTabelID,
			send_cabangid : uTokenObj.user_cabangid,
			send_databayar: JSON.stringify(uDatamainObj),
			send_tokenauth : uTokenObj.userinit
		});
		const vURLs	= pjson.homepage+"api2/api_rekapnota/pr_editnota";
		//const vURLs	= pjson.homepage+"api/api_bayar/_pr_test";

		const vTimeBegin = new Date();
		fetch(vURLs,{
			headers: { Accept: "application/json", "Content-Type": "application/json" },
			method: "POST",
			mode: "cors",
			cache: "default",
			body: vDATAS,
		}).then((response)=> { if (response.status === 200) { setSessionaktif(false); return response.json(); }})
		.then((output_string) => {
			setSessionaktif(true);
			if(output_string.sukses) {
				//setDlgformshow(false);
				showToast(uBahasaObj.pesan_sukses||"Berhasil !","SUKSES");
				uNavigate(uUrlbefore,{replace:true}); return;
				//uNavigate("/subbilling/rekapnota",{replace:true});
			} else if(output_string.expired) {
				prosesExpired(); return;
			} else {
				vEldisabled && (vEldisabled.disabled = false);
				setLoading(false); 
				if(output_string.info) {
					showToast(output_string.info);
				} else if(output_string.errors) {
					console.log("(Kasiredit - apiProsessimpan) output_string.errors : "+output_string.errors);
					const vMsg = (pjson.mydefault.environment==="development")
						? output_string.errors : pjson.mydefault.msgFetchError;
					showToast(vMsg,"ERROR");
				}
			}
		})
		.catch((error) =>{
			const vTimeEnd = new Date(); const vTimeDiff = vTimeEnd - vTimeBegin; //in ms
			console.log("(Kasiredit - apiProsessimpan) catch-error : "+error);
			showToast(pjson.mydefault.msg500str.join(" "),"ERROR");

			if(vTimeDiff > 35000) {
				uNavigate(-1);
				return;
			}
			vEldisabled && (vEldisabled.disabled = false);
			setLoading(false); 
		});
	}
	//---END REST_API--/

	//---EFFECT--/
	React.useEffect(()=>{
		document.addEventListener("keydown",hdlKDownDocument);

		return ()=>{
			document.removeEventListener("keydown",hdlKDownDocument);
		}
	})
	React.useEffect(()=>{
		uDispatch({type: "set", effectApp: !uEfekapp});
    	
    	apiLoaddata();

    	return () => {
    		setDataAsuransiArr([]); setDatapaymentArr([]);
    		setDataloadObj({}); setDatamainObj({}); 
    		setDlgformshow(false); setDlglookupshow(false);
    		setMainloading(false);
    	}
	},[])
	React.useEffect(()=>{
		if(uDataloadObj.tgl_bayar === undefined) {
			setDatamainObj({}); return;
		}

		setDatamainObj({...JSON.parse(JSON.stringify(uDataloadObj||{})), 
			init_diff: new Date().valueOf(),
		});
	},[uDataloadObj,uDataloadObj.tgl_bayar])
	/*React.useEffect(()=>{
		console.log("(Kasiredit - [uDatamainObj]) (2) uDatamainObj",uDatamainObj);
		console.log("(Kasiredit - [uDatamainObj]) (3) uDataloadObj",uDataloadObj);
	},[uDatamainObj])//-*/
	React.useEffect(()=>{
		if(uDatamainObj.init_diff === undefined) return;
		
		const vNilaitotal	= parseFloat(uDatamainObj.nilai_bruto ?? "0")
			- parseFloat(uDatamainObj.diskon ?? "0")
			- 0;
		setDatamainObj({...uDatamainObj,nilai_total: vNilaitotal});
	},[uDatamainObj.init_diff])
	React.useEffect(()=>{
		if(uDatamainObj.nilai_total === undefined) return;

		const vNilaitagihan	= parseFloat(uDatamainObj.nilai_total ?? "0")
			- parseFloat(uDatamainObj.bayar_before ?? "0")
			- parseFloat(uDatamainObj.nilai_asuransi ?? "0")
			- 0;

		setDatamainObj({...uDatamainObj,nilai_tagihan: vNilaitagihan});
	},[uDatamainObj.nilai_total,uDatamainObj.nilai_asuransi])
	React.useEffect(()=>{
		if(uDatamainObj.nilai_tagihan === undefined) return;

		const vNilaisisa	= parseFloat(uDatamainObj.nilai_tagihan ?? "0")
			- parseFloat(uDatamainObj.nilai_uang ?? "0")
			- 0;

		setDatamainObj({...uDatamainObj,nilai_sisa: vNilaisisa});
	},[uDatamainObj.nilai_tagihan,
	uDatamainObj.nilai_uang,
	])
	React.useEffect(()=>{
		if(parseFloat(uDatamainObj.nilai_uang ?? "0") !== parseFloat(uDataloadObj.nilai_uang ?? "0")
			|| (uDatamainObj.payment_arr||[]).length !== (uDataloadObj.payment_arr||[]).length
			) setDataupdated(true);
		else setDataupdated(false);
	},[uDatamainObj.nilai_uang,
	(uDatamainObj.payment_arr||[]).length,
	])
	React.useEffect(()=>{
		if(!uISDlgformshow) {
			setDlgformObj({});return;
		}

		const vTimeout = setTimeout(()=>{
			clearTimeout(vTimeout);
			
			let vElfocus = document.getElementById("inppaymentcaption");
			if(uDlgformObj.dlg_jenis === "PAYMENT") {
				if(parseInt(uDlgformObj.idxkey ?? "-1") >= 0)
					vElfocus = document.getElementById("inpjmlbayar");
			} else if(uDlgformObj.dlg_jenis === "FORMMAIN") 
				vElfocus = document.getElementById("btnDialogSimpan");

			if(!isMobile) vElfocus && vElfocus.focus();
		},350);
	},[uISDlgformshow])
	React.useEffect(()=>{
		if(!uISChangetriggered) return;

		setChangetriggered(false);
		const vNilaibayar = (uDatamainObj.payment_arr||[]).
			filter(vItems=>(vItems.status_hapus||"TIDAK")==="TIDAK").
			reduce((vSUMS,vItems)=>
			vSUMS + parseFloat(vItems.nilai_bayar ?? "0")
			,0);

		const vNilaiuang = (uDatamainObj.payment_arr||[]).
			filter(vItems=>(vItems.status_hapus||"TIDAK")==="TIDAK").
			reduce((vSUMS,vItems)=>
			vSUMS + parseFloat(vItems.nilai_uang ?? "0")
			,0);

		setDatamainObj({
			...uDatamainObj,
			nilai_bayar: vNilaibayar,
			nilai_uang: vNilaiuang,
		});
	},[uISChangetriggered])
	//---END EFFECT--/

	//console.log("(Kasiredit) uDataloadObj => ",uDataloadObj)
	if(UFunc.isEmpty(uTokenObj)) { prosesExpired(); return ""; }

	return (
		<>
		<div className="wrapper d-flex flex-column min-vh-100 bg-transparent">
		<CHeader position="sticky" className="mb-3 p-0">
		<CContainer fluid className="classheadertop" style={{minHeight:64}}>
			<CHeaderToggler className="px-0" onClick={() => hdlKlikBack() }>
			<CIcon icon="cilArrowCircleLeft" className="align-top me-2" height={30}/>
			</CHeaderToggler>
			
			<CHeaderBrand className="me-auto text-normal">
				<b>Edit Nota</b>
			</CHeaderBrand>

			<CHeaderNav>
				<MyHeaderProfile {...props}/>
			</CHeaderNav>
		</CContainer>

		<CContainer fluid className="bg-white p-2 px-3" style={{minHeight:52}}>
			{contentHeadersub()}
		</CContainer>
		</CHeader>

		<div className="body flex-grow-1 px-2 px-lg-5">
		{(uISMainloading) ? (
		<div className="py-5 my-5 text-center h-100" style={{minHeight:"500px important"}}>
			<small className="text-primary py-5 my-5 fst-italic classblinking">Mohon Ditunggu...</small>
		</div>
		) : (
		<CContainer xxl className="px-0">
			{(uHtml500msg) ? (
			<CCard className="classbgcard mb-2">
			<CCardHeader>Error Page 500</CCardHeader>
			<CCardBody className="p-md-5 py-5">
				<div className="mx-3">{UFunc.renderHTML(uHtml500msg)}</div>
			</CCardBody>
			</CCard>
			) : (
			<CForm>
			<CRow>
			<CCol lg="6" className="" style={{display:"flex",flexDirection:"column"}}>
				<CCard className="classbgcard mb-3">
				<CCardHeader className="classfontsmaller py-0 pt-1"><small>Data Nota</small></CCardHeader>
				<CCardBody className="px-0">
					<div className="px-3">{contentNota()}</div>

					<div className="d-lg-none classborderbottom my-3"/>

					<div className="d-lg-none px-0 px-md-3">
					{contentItem()}
					</div>
				</CCardBody>
				</CCard>

				<CCard className="classbgcard mb-3 d-none d-lg-block" style={{flex: "1 0 0"}}>
				<CCardHeader className="classfontsmaller py-0 pt-1"><small>Item Terapi</small></CCardHeader>
				<CCardBody className="px-0">{contentItem()}</CCardBody>
				</CCard>
			</CCol>

			<CCol lg="6" className="" style={{display:"flex",flexDirection:"column"}}>
				<CCard className="classbgcard mb-3">
				<CCardHeader className="classfontsmaller py-0 pt-1"><small>Data Asuransi</small></CCardHeader>
				<CCardBody>{contentAsuransi()}</CCardBody>
				</CCard>

				<CCard className="classbgcard mb-3" style={{flex: "1 0 0"}}>
				<CCardHeader className="classfontsmaller py-0 pt-1"><small>Data Payment</small></CCardHeader>
				<CCardBody>{contentPayment()}</CCardBody>
				</CCard>
			</CCol>
			</CRow>
			</CForm>
			)}
		</CContainer>
		)}
		</div>

		<CFooter position="sticky" className="px-3 text-black-50 justify-content-center" 
			style={{backgroundColor:"#AEAEAE"}}>
		<MyButton
			disabled={uISMainloading || (uHtml500msg!==undefined) || uISDlgformshow}
			onClick={()=>hdlKlikSimpanmain()}
			id="btnSimpanmain">{uBahasaObj.word_simpan||"Simpan"} [F9]</MyButton>
		</CFooter>
			
		</div>

		<MyDialoglookup
			show={uISDlglookupshow}
			toggle={()=>setDlglookupshow(false)}
			dialogHeader={uDlglookupObj.dlg_header||"Lookup Data"}
			inputValue={uDlglookupObj.dlg_input || ""}
			dataItemArr={uDlglookupObj.data_arr || []} 
			onKlikPilihItem={hdlDlglookupKlikpilih}
			id="iddialoglookup"
			{...props}/>

		<MyDialogform
			options={{centered:true}}
			onSimpan={hdlKlikDlgformsimpan}
			show={uISDlgformshow} 
			dialogHeader={uDlgformObj.dlg_header}
			toggle={()=>setDlgformshow(false)}
			renderContent={contentDlgform()}/>
		</>
	)//>
}	

export default Kasiredit